// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"_93444fe79c--thumbnail--h1mYS"};